<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="BGVPoliciesForm" (ngSubmit)="Validate(BGVPoliciesForm)" #BGVPoliciesForm="ngForm"
        novalidate>

        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Background Verification Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="PolicyName" class="form-label text-label-dark">Policy Name
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="PolicyName" name="PolicyName" [(ngModel)]="BackgroundVerificationDetail.PolicyName"
                                #RegularizationRuleTitle="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="ess_bgvApiMasterId" class="form-label text-label-dark">Vendor
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <select class="form-select text-label-light" aria-label="Vendors" placeholder="Vendors"
                                title="Vendors" name="ess_bgvApiMasterId"
                                [(ngModel)]="BackgroundVerificationDetail.ess_bgvApiMasterId"
                                (change)="onVendorChange()" #ess_bgvApiMasterId="ngModel" required>
                                <option disabled [value]=null>--Select Vendor--</option>
                                <option *ngFor="let Vendor of Vendors" [value]=Vendor.ESS_BGVApiMasterID>
                                    {{Vendor.APIName}}</option>
                            </select>
                            <div class="invalid-feedback">
                                Please Select Vendor!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="Checks" class="form-label text-label-dark">Checks
                                :</label>
                        </div>
                        <div class="col">
                            <ul class="list-group" *ngIf="CheckLists.length > 0">
                                <li class="list-group-item m-0 p-1">
                                    <div class="row text-label-dark">
                                        <div class="col-md-5">Name</div>
                                        <div class="col-md-2">Verification</div>
                                        <div class="col-md-2">Mandatory</div>
                                        <div class="col-md-3">Initiation Days</div>
                                    </div>
                                </li>

                                <div *ngFor="let CheckList of CheckLists; let i = index">
                                    <li class="list-group-item text-label-light">
                                        <div class="row">
                                            <div class="col-md-5">{{CheckList.CheckListName}}</div>
                                            <div class="col-md-2 text-center">
                                                <input class="form-check-input" type="checkbox" id="IsVerification{{i}}"
                                                    name="IsVerification{{i}}" [(ngModel)]="CheckList.IsVerification" (change)="VerificationCheck($event,i)">
                                            </div>
                                            <div class="col-md-2 text-center">
                                                <input class="form-check-input" type="checkbox" id="IsMandatory{{i}}"
                                                    name="IsMandatory{{i}}" [(ngModel)]="CheckList.IsMandatory" (change)="MandatoryCheck($event,i)">
                                            </div>
                                            <div class="col-md-3">
                                                <div class="input-group">
                                                    <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                                        (keypress)="common.NumberOnly($event)"
                                                        class="form-control text-label-light"
                                                        [ngClass]="{'ng-invalid': common.parseFloat(CheckList.InitiationDays) > 365}"
                                                        placeholder="Ex. 01" id="InitiationDays{{i}}"
                                                        name="InitiationDays{{i}}"
                                                        [(ngModel)]="CheckList.InitiationDays" #InitiationDays="ngModel"
                                                        [disabled]="!CheckList.IsVerification"
                                                        required>
                                                    <span class="input-group-text" id="basic-InitiationDays">day</span>
                                                    <div class="invalid-feedback">
                                                        Please enter maximum days 365!
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.BackgroundVerificationDetail.ESS_bgvPolicyID == 0) || (this.BackgroundVerificationDetail.ESS_bgvPolicyID > 0 && common.ToLowerCase(BackgroundVerificationDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="BackgroundVerificationDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="BackgroundVerificationDetail.ESS_bgvPolicyID > 0"
                                        (change)="GetApplicability()" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.BackgroundVerificationDetail.ESS_bgvPolicyID == 0) || (this.BackgroundVerificationDetail.ESS_bgvPolicyID > 0 && common.ToLowerCase(BackgroundVerificationDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="BackgroundVerificationDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="BackgroundVerificationDetail.ESS_bgvPolicyID > 0"
                                        (change)="GetApplicability()" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center me-2">
                            <label for="DefaultPolicy" class="form-label text-label-dark">Default Policy
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="DefaultPolicy"
                                        [(ngModel)]="BackgroundVerificationDetail.DefaultPolicy"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="DefaultPolicy"
                                        [(ngModel)]="BackgroundVerificationDetail.DefaultPolicy"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="BackgroundVerificationDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && BackgroundVerificationDetail.DefaultPolicy">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && BackgroundVerificationDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.BackgroundVerificationDetail.ESS_bgvPolicyID == 0) || (this.common.PageRight.IsEdit && this.BackgroundVerificationDetail.ESS_bgvPolicyID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>